import React from 'react';

const BuyersOnMap: React.FC = () => {
  return <></>;
};

export default React.memo(BuyersOnMap);
